import _ from 'lodash';

const mergeObjectsRemovingNullValues = (currentParams, newParams) => {
  const mergedParams = { ...currentParams, ...newParams };

  Object.keys(mergedParams).forEach((key) => {
    if (mergedParams[key] === null || mergedParams[key] === undefined || mergedParams[key] === '') {
      delete mergedParams[key];
    }
  });

  return mergedParams;
};

const updateQuery = async (router, route, newParams) => {
  const mergedQuery = mergeObjectsRemovingNullValues(route.query, newParams);
  if (!_.isEqual(route.query, mergedQuery)) {
    await router.push({ query: mergedQuery });
  }
};

function pageFromRouteQuery(pageQuery, defaultPage = 1) {
  if (pageQuery === undefined || pageQuery === null || pageQuery === '') return defaultPage;

  const raw = Array.isArray(pageQuery) ? pageQuery[0] : pageQuery;
  if (raw === undefined || raw === null || raw === '') return defaultPage;

  const number = parseInt(String(raw), 10);
  if (!Number.isFinite(number) || number < 1) return defaultPage;

  return number;
}

export { updateQuery, mergeObjectsRemovingNullValues, pageFromRouteQuery };
